import { gql } from 'apollo-angular';

const GET_LEAF_NODE_CATEGORIES = gql`
  query GetLeafeNodeCategories($rfpId: Long) {
    rfp(id: $rfpId) {
      leafNodeCategories {
        id
        name
        formularyUnitPrice
        formularyBaseUom
        parents {
          id
          name
        }
      }
    }
  }
`;

export default GET_LEAF_NODE_CATEGORIES;
